<template>
  <div class="portrait-wrapper">

    <div class="portrait-content" :class="moduleType" v-loading="loadingVisible">

      <!-- 标题和关闭按钮 -->
      <div class="portrait-header">
        <h3>{{ moduleTitleMap[moduleType] }}</h3>
        <i class="iconfont iconx" @click.stop="closePortraitDialog()" v-show="!notWatermarkImage"></i>
      </div>

      <!-- 模块 上传简历头像入口 -->
      <comp-entry v-show="moduleType === 'entry'"
                  @upImgChangeFunc="entryUpImgChangeFunc"
                  @upPhoneImgTriggerFunc="entryUpPhoneImgTriggerFunc" />

      <!-- 模块 裁剪图片 -->
      <comp-cut v-if="moduleType === 'cut'"
                :cutType="cutType"
                :imgFile="imgFile"
                @upLocalImgFunc="cutUpLocalImgFunc"
                @upPhoneImgFunc="cutUpPhoneImgFunc"
                @goBackLocalFunc="cutGoBackLocalFunc"
                @goBackPhoneFunc="cutGoBackPhoneFunc" />

      <!-- 模块 上传图片二维码 -->
      <comp-qrcode v-if="moduleType === 'qrcode'"
                   @uploaded="qrcodeUploaded"
                   @goBackFunc="qrcodeGoBackFunc" />

      <!-- 模块 美颜 -->
      <comp-beauty v-if="moduleType === 'beauty'" ref="beauty"
                   :originPhoto="originPhoto"
                   :watermarkedPhoto="watermarkedPhoto"
                   :cutPhotoFile="cutPhotoFile"
                   :userPhotoCount="userPhotoCount"
                   @save-cv="saveCvImage"
                   @goToCut="beautyGoToCut"
                   @toggleLoading="toggleLoadingFunc"
                   @updateBeautyPhoto="beautyUpdateBeautyPhoto"
                   @togglePayDialogVisible="togglePayDialogVisibleFunc"
                   @updateNoWatermarkedPhoto="beautyUpdateNoWatermarkedPhotoFunc" />

    </div>

    <!-- 美颜购买支付弹窗 -->
    <transition name="opacity">
      <comp-pay v-if="payDialogVisible"
                :payLoadingVisible="payLoadingVisible"
                :userPhotoCount="userPhotoCount"
                @getNoWatermarkedPhoto="getNoWatermarkedPhotoFunc"
                @togglePayDialogVisible="togglePayDialogVisibleFunc" />
     </transition>

    <!-- 二次确认弹窗 -->
    <transition name="opacity">
      <comp-tips v-show="tipsVisible"
                 tipsTitle="温馨提示"
                 tipsText="编辑的照片还未保存，是否放弃当前操作照片？"
                 @confirmFunc="tipsConfirmFunc"
                 @cancelFunc="tipsCancelFunc" />
    </transition>

  </div>
</template>

<script>
import CompEntry from './entry'
import CompCut from './cut'
import CompQrcode from './qrcode'
import CompBeauty from './beauty'
import CompPay from './pay'
import CompTips from '@/components/alert/tipsBlock.vue'

import api from '@/api'
import downloadjs from 'downloadjs'

import { uuid } from 'vue-uuid'
import { VueCropper } from 'vue-cropper'
import { mapState, mapMutations, mapActions } from 'vuex'
import { dataURLtoBlob, blobToFile } from '@/assets/js/util'

const oss = require('ali-oss')

export default {
  data () {
    return {
      /**
       * 模块相关
       */
      moduleType: 'entry', // 当前模块类型 可能的值：1. entry 入口  2. cut 裁剪  3. qrcode 二维码  4. beauty 美颜
      moduleTitleMap: { // 当前模块标题
        entry: '添加简历照片',
        cut: '裁剪照片',
        qrcode: '制作证件照',
        beauty: '编辑照片'
      },
      cutType: null, // 裁剪模块类型 可能的值：1. local 本地上传 2. phone 手机上传
      payDialogVisible: false, // 控制支付弹窗的出现和隐藏
      tipsVisible: false, // 二次确认弹窗
      /**
       * 图片相关
       */
      imgFile: null, // 图片文件
      imgType: null, // 图片类型
      originPhoto: null, // 无水印照片 用于作为参数调接口
      watermarkedPhoto: null, // 有水印的照片 用于页面展示
      noWatermarkedPhotoFile: '', // 无水印照片 base64
      noWatermarkedPhotoParams: { // 获取无水印照片需要的参数
        fileName: null,
        clothesId: null
      },
      qrcodeUploadImgCache: null, // 缓存每次二维码上传成功的图片 用于 beauty 模块 再次裁剪

      cropperImgfile: '', // 用于裁剪插件裁剪的图片 v4.7.0 可删除
      /**
       * 其他
       */
      userPhotoCount: 0, // 用户可制作证件照次数
      loadingVisible: false,
      payLoadingVisible: false,
      cutPhotoFile: '', //裁剪完之后的原图
    }
  },
  components: {
    CompEntry, // 上传简历头像入口
    CompCut, // 裁剪图片
    CompQrcode, // 上传图片二维码
    CompBeauty, // 美颜
    CompPay, // 最终图片下载和保存 还有支付
    CompTips, // 自定义弹窗
    VueCropper
  },
  created () {
    // 出现蒙层时防止可滚动
    document.body.style.position = 'static'
    document.body.style.overflow = 'hidden'

    this.getUsePhotoCountFunc()
  },
  destroyed () {
    // 组件销毁时还原
    document.body.style.position = 'initial'
    document.body.style.overflow = 'initial'
  },
  computed: {
    ...mapState('global', ['ossBeaseOptions']),
		...mapState('editor', ['profile', 'cvDetail', 'backUpProfile', 'notWatermarkImage']),
    ...mapState('me', [ 'personInfo' ]),
    isMembership(){
      return this.personInfo.is_membership
    },
  },
  // watch: {
  //   profile: {
  //     deep: true,
  //     immediate: true,
  //     keep: true,
  //     handler(val) {
  //       console.log('profile=>>>', val)
  //     }
  //   },
  // },
  methods: {
    ...mapActions('editor', ['createCvDetail', 'createProfileData', 'updateProfileData', 'updateVipProfileData']),
    ...mapMutations('editor', ['setBackUpProfile', 'setPortraitDialogVisible', 'setNotWatermarkImage']),

    closePortraitDialog () {
      // 在 beauty 模块 关闭弹窗会有二次确认
      if (this.moduleType === 'beauty') {
        this.tipsVisible = true
      } else {
        this.setPortraitDialogVisible(false)
      }
    },
    // 切换 loading 状态
    toggleLoadingFunc (val) {
      this.loadingVisible = val
    },
    // tips 弹窗 确认回调
    tipsConfirmFunc () {
      this.setPortraitDialogVisible(false)
    },
    // tips 弹窗 取消回调
    tipsCancelFunc () {
      this.tipsVisible = false
    },
    // 重新裁剪
    beautyGoToCut () {
      this.imgFile = this.qrcodeUploadImgCache
      this.cutType = 'phone'
      this.moduleType = 'cut'
    },
    // 更新获取无水印照片需要的参数
    beautyUpdateNoWatermarkedPhotoFunc (val) {
      this.noWatermarkedPhotoParams = val
    },
    // 控制支付弹窗的出现和隐藏
    togglePayDialogVisibleFunc (val) {
      // 显示支付弹窗前先获取 次数
      if (val) {
        this.getUsePhotoCountFunc(() => {
          this.payDialogVisible = val
        })
      } else {
        this.payDialogVisible = val
      }
    },
    // 裁剪 上传本地图片
    cutUpLocalImgFunc (val) {
      // 关闭弹窗
      this.setPortraitDialogVisible(false)
      // 上传图片到简历
      this.upImgToCvFunc(val, this.imgType)
    },
    // 裁剪 上传手机图片
    cutUpPhoneImgFunc (val) {
      this.upPhotoToBeautyFunc(val)
    },
    // 裁剪（本地） 上一步
    cutGoBackLocalFunc () {
      this.imgFile = ''
      this.moduleType = 'entry'
    },
    // 裁剪（手机） 上一步
    cutGoBackPhoneFunc () {
      this.moduleType = 'qrcode'
    },
    // 检测到手机照片上传成功
    qrcodeUploaded (val) {
      this.imgFile = val
      // 存储每次二维码上传成功的原图 只用于 在 beauty 模块的再次裁剪
      this.qrcodeUploadImgCache = val
      this.moduleType = 'cut'
    },
    // 二维码 上一步
    qrcodeGoBackFunc () {
      this.moduleType = 'entry'
    },
    // 手机上传图片
    entryUpPhoneImgTriggerFunc () {
      this.cutType = 'phone'
      this.moduleType = 'qrcode'
    },
    // 监听本地图片上传
    entryUpImgChangeFunc (file) {
      this.cutType = 'local'
      // 切换到 裁剪模块
      this.moduleType = 'cut'
      // 重置图片文件
      this.imgFile = null
      // 获取图片类型
      this.imgType = file[0].type.split('/')[1]
      // 处理新上传的图片文件 base64
      const reader = new FileReader()
      reader.readAsDataURL(file[0])
      reader.onload = e => {
        this.imgFile = e.currentTarget.result
      }
    },
    // 更新水印照片
    beautyUpdateBeautyPhoto (val) {
      this.originPhoto = val.origin
      this.watermarkedPhoto = val.watermarked
    },
    // 获取可制作证件照次数
    async getUsePhotoCountFunc (callback) {
      this.toggleLoadingFunc(true)
      try {
        let res = await api.portrait.getUsePhotoCount()
        if (res.code === 1000) {
          this.userPhotoCount = res.data.count
          callback && callback()
        } else {
          this.$message.error(res.msg || res.message)
        }
        this.toggleLoadingFunc(false)
      } catch (error) {
        console.log(error)
        this.toggleLoadingFunc(false)
      }
    },
    // 获取无水印证件照
    async getNoWatermarkedPhotoFunc () {
      this.payLoadingVisible = true
      try {
        let params = {
          file_name: this.noWatermarkedPhotoParams.fileName,
          clothes: this.noWatermarkedPhotoParams.clothesId === -1 ? null : this.noWatermarkedPhotoParams.clothesId
        }
        let res = await api.portrait.getNoWatermarkedPhoto(params)
        if (res.code === 1000) {
          // 1. 触发浏览器下载一寸证件照
          this.noWatermarkedPhotoFile = 'data:image/jpg;base64,' + res.data.img
          this.payDialogVisible = false
          downloadjs(this.noWatermarkedPhotoFile, '超级简历证件照.png', "image/png")
          this.setNotWatermarkImage(this.noWatermarkedPhotoFile)
        } else {
          this.$message.error(res.msg || res.message)
        }
        this.payLoadingVisible = false
      } catch (error) {
        console.log(error)
        this.payLoadingVisible = false
      }
    },
    // 获取有水印的照片 用于下一步照片美颜操作
    async upPhotoToBeautyFunc (val) {
      this.toggleLoadingFunc(true)
      try {
        this.cutPhotoFile = val.split('base64,')[1];

        let params = {
          file: val.split('base64,')[1],
          background_color: 'white', // 背景色
          fair_level: { // 当前美颜
            skinsoft: 0.4, // 磨皮
            mouthlarge: 0.6, // 嘴巴
            skinwhite: 0.6, // 美白
            facelift: 0.6, // 瘦脸
            leyelarge: 0.6, // 左眼
            reyelarge: 0.6, // 右眼
            coseye: 0.6 // 亮眼
          }, // 美颜参数
          clothes: null,
        }
        let res = await api.portrait.editPhotoBeauty(params)
        if (res.code === 1000) {
          // 照片检测通过
          if (res.data.status === 'success') {
            // 拿到无水印图片 用于作为参数调接口
            this.originPhoto = res.data.source_file
            // 拿到有水印的照片 用于页面展示
            this.watermarkedPhoto = res.data.file_name_wm
            this.$message.success('裁剪成功')
            this.moduleType = 'beauty'
            // 在裁剪照片模块 要去编辑模块前 会调这个接口 拿到 有水印的默认图
            // 这时 需要 同步一下图片文件 如果用户什么也不编辑直接下载的话 就会拿这个文件名去请求
            this.noWatermarkedPhotoParams.fileName = res.data.file_name
            this.noWatermarkedPhotoParams.clothesId = null
          // 照片检测不通过
          } else if (res.data.status === 'error') {
            this.$message.error('未通过照片检测')
          }
        } else {
          this.$message.error(res.msg || res.message)
        }
        this.toggleLoadingFunc(false)
      } catch (error) {
        console.log(error)
        this.toggleLoadingFunc(false)
      }
    },
    // 图片上传到简历
    async upImgToCvFunc (file, fileType) {
      try {
        const { basic_info: { kind, token } } = this.cvDetail

        // 买会员
        // if(!this.isMembership){
        //   this.buyMember()
        //   return
        // }

        //同步个人信息数据
        console.log(this)
        let profile = JSON.parse(JSON.stringify(this.profile || this.backUpProfile))
        // console.log('11profile=>>>', profile)
        let store = await oss(this.ossBeaseOptions)
        let imgName = `${uuid.v1()}.${fileType}`
        //调用
        var blob = dataURLtoBlob(file)
        var fileData = blobToFile(blob, imgName)
        let res = await store.put(`cv/cv_accounts/avatars/${ imgName }`, fileData)
        if (res.res.statusCode !== 200) {
          this.$message.error('图片上传失败')
          return false
        }
        profile.avatar_url = res.url;
        delete profile.show_attr_name;
        if (kind === 'template' || kind === 'sample') {
          try {
            let cvRes = await this.createCvDetail({
              payload: JSON.parse(JSON.stringify(this.cvDetail)),
              dotReload: true
            })
            if (cvRes.code === 1000) {
              this.createProfileData({ payload: profile })
            }
            this.setNotWatermarkImage('')
          } catch (error) {
            console.log(error)
          }
        } else if (!this.profile.id) {
          this.createProfileData({ payload: profile, dotReload: true })
        } else {
          this.hasCvUpdateProfileFunc(profile)
        }
        this.setNotWatermarkImage('')
      } catch (error) {
        console.log(error)
        this.$message.error('图片上传失败')
        return false
      }
    },
    // 已有简历和profile上传头像
		async hasCvUpdateProfileFunc(profile) {
			try {
				//同步数据
				let profileRes = await this.updateVipProfileData({ payload: {avatar_url: profile.avatar_url}, profile: profile });
				if (profileRes.code === 1000) {
					this.$message.success('保存成功')
					//同步个人信息备份数据-有可能用户在修改排版样式，不能影响
					let backUpProfile = JSON.parse(JSON.stringify(this.backUpProfile))
					backUpProfile.avatar_url = profileRes.url
					this.setBackUpProfile(profile)
				} else {
          if(profileRes.code === 600213){
            // 买会员
            this.buyMember()
          }
					this.$message.error(profileRes.message)
				}
			} catch (error) {
				console.log(error)
			}
		},
    //保存照片到简历里面
    saveCvImage(){
      this.$refs.beauty.$refs.vueCropper2.getCropData(file => {
        this.upImgToCvFunc(file, 'png')
        this.setPortraitDialogVisible(false)
      })
    },
    // 去买会员
    buyMember(){
      this.$store.dispatch('app/setAlertData', {
        show: true,
        type: 'upVip',
        browseType: 'avatar'
      })
    },
  }
}
</script>

<style lang="scss" scoped>
  @import "./index.scss";
  .cropper2 {
    width: 400px !important;
    left: -1280px !important;
    opacity: 0 !important;
  }
</style>
